import * as React from "react";
import { forwardRef } from "react";
const SvgIconChatOptions = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.66 3.52L16.49 6.35L13.66 9.18L10.83 6.35L13.66 3.52ZM6 4V8H2V4H6ZM16 14V18H12V14H16ZM6 14V18H2V14H6ZM13.66 0.690002L8 6.34L13.66 12L19.32 6.34L13.66 0.690002ZM8 2H0V10H8V2ZM18 12H10V20H18V12ZM8 12H0V20H8V12Z", fill: "#DADADA" }));
const ForwardRef = forwardRef(SvgIconChatOptions);
export default ForwardRef;
